import { render, staticRenderFns } from "./JoyStick.vue?vue&type=template&id=074d88af&scoped=true"
import script from "./JoyStick.vue?vue&type=script&lang=js"
export * from "./JoyStick.vue?vue&type=script&lang=js"
import style0 from "./JoyStick.scss?vue&type=style&index=0&id=074d88af&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074d88af",
  null
  
)

export default component.exports